"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageContainer = void 0;
const react_1 = __importStar(require("react"));
const useImageServiceHook_1 = require("../../hooks/useImageServiceHook");
const SizedImage_1 = require("../SizedImage/SizedImage");
const styles_1 = require("./styles");
exports.ImageContainer = (0, react_1.memo)((_a) => {
    var { src, alt, width, height } = _a, rest = __rest(_a, ["src", "alt", "width", "height"]);
    const [hasError, setHasError] = (0, react_1.useState)(false);
    const { config } = (0, useImageServiceHook_1.useImageService)();
    const handleServiceError = (0, react_1.useCallback)(() => {
        setHasError(true);
    }, [setHasError]);
    if (hasError) {
        return (react_1.default.createElement(styles_1.ErrorFallbackImage, Object.assign({ src: src, alt: alt, height: height, width: width }, rest)));
    }
    const shouldUseEnhancement = config === null || config === void 0 ? void 0 : config.enableEnhancement;
    return shouldUseEnhancement ? (react_1.default.createElement(SizedImage_1.SizedImage, Object.assign({ src: src, alt: alt, handleServiceError: handleServiceError, height: height, width: width }, rest))) : (react_1.default.createElement(styles_1.StyledFallbackImage, Object.assign({ src: src, alt: alt }, rest)));
});
exports.ImageContainer.displayName = 'ImageContainer';
//# sourceMappingURL=ImageContainer.js.map